export const UNAVAILABILITY_TEXT = {
	errorFallback: 'Error ',
	scheduleAbsenceButton: 'Schedule Absence',
	noResults: 'No results',
	deleteIconTitle: 'Delete absence',
	deleteAlreadyProcessedErrorHeader: 'Error!',
	deleteAlreadyProcessedErrorLabel:
		"This absence can't be deleted as it has already been processed for payment",
};

export const ALL_REASONS_KEY = 'all_reasons';
